import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { useDeleteCommiteeBank } from '@/api/commitee/commitee.mutations';
import { type CommiteeBank, useCommiteeBanks } from '@/api/commitee/commitee.queries';
import { Title } from '@/components/Title';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import { BankDialog } from '@/features/account/bank/BankDialog';
import { getCommiteeBanksColumns } from '@/features/account/bank/columns/banks-columns';

export const Route = createFileRoute('/gestion/entreprise/$id/banque')({
  component: BanqueTab,
});

function BanqueTab() {
  const { id } = Route.useParams();
  const commiteeId = Number(id);
  const { data: banks, isLoading, isError } = useCommiteeBanks(commiteeId);
  const { mutate: deleteBank } = useDeleteCommiteeBank(commiteeId);
  const [bankToEdit, setBankToEdit] = useState<CommiteeBank | null>(null);

  const columns = useMemo(
    () =>
      getCommiteeBanksColumns({
        onEdit: setBankToEdit,
        onDelete: async (bank) => {
          await deleteBank(bank.id);
        },
      }),
    [deleteBank]
  );
  const tableState = useTableState('commitee-banks', { columns });

  return (
    <div className="flex flex-col gap-4">
      <Title>Banques{banks ? ` (${banks.length})` : ''}</Title>
      <Table
        entity={{ singular: 'banque', feminine: true }}
        data={banks}
        columns={columns}
        tableState={tableState}
        disableHover
        isLoading={isLoading}
        isError={isError}
      />
      {bankToEdit && (
        <BankDialog
          key={bankToEdit.id}
          open
          onOpenChange={(open) => !open && setBankToEdit(null)}
          bank={bankToEdit}
        />
      )}
    </div>
  );
}
